import { i, s, x } from '../../lit-element.js';
import { o as o$1 } from '../../class-map.js';
import { o } from '../../unsafe-html.js';
import disclosures from './assets/disclosures.js';
import { reset } from '../../styles/reset.style.js';
import { links } from '../../styles/links.style.js';
import '../../directive.js';

const style = i`
  :host {
    border-bottom: 1px solid #d4d4d4;
    border-top: 1px solid #d4d4d4;
    display: block;
    padding: 1.5em;
  }

  :host([hidden]) {
    display: none;
  }

  .disclosures-header {
    margin-bottom: 1em;
  }

  h5 {
    display: inline-block;
    font-size: 1em;
    font-weight: 400;
    margin-bottom: 1em;
  }

  .disclosures-header a {
    display: inline-block;
  }

  @media (min-width: 48em) {
    h5 {
      margin-bottom: 0;
    }

    .disclosures-header a {
      float: right;
    }
  }

  .disclosures-content {
    background: #fff;
    border: 1px solid #d4d4d4;
    color: #141414;
    font-size: 0.75em;
    height: 140px;
    overflow: auto;
    padding: 1em;
  }

  .disclosures-content.open {
    height: auto;
  }

  .disclosures-content p:not(:last-of-type) {
    padding-bottom: 10px;
  }

  .disclosures-content h6 {
    font-size: 1em;
    font-weight: 600;
    padding-bottom: 1em;
  }

  .disclosures-content ul {
    font-weight: 300;
    padding-left: 2.5em;
  }

  .disclosures-content ul li {
    padding-bottom: 0.75em;
  }

  .disclosures-content ul li span {
    font-weight: 600;
  }

  .disclosures-content ul li ul li {
    list-style: disc;
    padding: 0.75em 0 0;
  }
`;

class RefiDisclosures extends s {
  constructor() {
    super();
    this.triggerText = '+ Show All';
    this.isExpanded = false;
    this.item = disclosures;
  }

  static get properties() {
    return {
      isExpanded: { type: Boolean },
      item: { type: Object },
    };
  }

  static get styles() {
    return [reset, links, style];
  }

  render() {
    const contentfullContent = o(this.item.disclosures) || '';
    return x`
      <div class="disclosures-header" data-e2e-ref="disclosuresHeader">
        <h5>${this.item.title || ''}</h5>
        <a class="grv-link" href="#" @click="${this.toggleDisclosures}" data-e2e-ref="toggleDisclosures">${this.triggerText}</a>
      </div>
      <div tabindex="0" class="disclosures-content ${o$1({ open: this.isExpanded })}" data-e2e-ref="disclosuresContent">
        <refi-common-chariot content-name="AllDisclosures.ecm.json" content-path="content.0.sections.0.items.3.values.0.value"> ${contentfullContent} </refi-common-chariot>
      </div>
    `;
  }

  toggleDisclosures(ev) {
    ev.preventDefault();
    this.isExpanded = !this.isExpanded;
    this.triggerText = this.isExpanded ? `- Hide All` : `+ Show All`;
  }
}

export { RefiDisclosures };
